module.exports = __webpack_public_path__ + "static/media/Last1.7abee6e6.jpg";